import request from '@/utils/request'

export const getTableData = params =>
  request.post('/customer-api/customer/page', params)

// 添加黑名单
export const addBlackList = params =>
  request.post(`/customer-api/customer/blacklist/add`, params)

export const addCustomerType = params =>
  request.post(`/customer-api/customer/copyAddBase`, params)
// 移除黑名单
export const removeBlackList = id =>
  request.get(`/customer-api/customer/blacklist/remove/${id}`)
// 新增用户查看客户日志
export const getAddlog = params =>
  request.post('/customer-api/company-search-logs/add', params)
// 添加关注
export const addToWatchList = params => {
  request.post(`/customer-api/watch-list/add/${params.companyId}`)
}

// 取消关注
export const removeWatchList = params => {
  request.get(`/customer-api/watch-list/delete/${params.companyId}`)
}
